(() => {
  // Safe when the section asset is emitted more than once on the same page.
  if (customElements.get('back-to-top-button')) return;
class BackToTopButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('a');
    this.offset = parseInt(this.dataset.offset, 10) || 600;
    this.isScrolling = false;
    this.scrollFrame = null;
    this.animationFrame = null;
    this.abortController = null;
  }

  connectedCallback() {
    if (!this.button) return;
    this.abortController?.abort();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    window.addEventListener('scroll', () => {
      if (!this.isScrolling) {
        this.scrollFrame = window.requestAnimationFrame(() => {
          this.trackScroll();
          this.isScrolling = false;
        });
        this.isScrolling = true;
      }
    }, { passive: true, signal });

    this.button.addEventListener('click', this.scrollToTop.bind(this), { signal });
    
    // Comprobación inmediata al cargar
    this.trackScroll();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    cancelAnimationFrame(this.scrollFrame);
    cancelAnimationFrame(this.animationFrame);
    this.isScrolling = false;
  }

  trackScroll() {
    const scrolled = window.scrollY;
    // Añadimos 'show' solo si superamos el offset
    if (scrolled > this.offset) {
      this.classList.add('show');
      this.removeAttribute('aria-hidden');
    } else {
      this.classList.remove('show');
      this.setAttribute('aria-hidden', 'true');
    }
  }

  scrollToTop(event) {
    event.preventDefault();
    cancelAnimationFrame(this.animationFrame);
    
    // Lógica de Scroll Suave (Smooth Interpolation)
    const duration = 800; 
    const start = window.scrollY;
    const startTime = performance.now();

    const easeInOutCubic = (t) => {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };

    const animateScroll = (currentTime) => {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutCubic(progress);

      window.scrollTo(0, start * (1 - ease));

      if (timeElapsed < duration) {
        this.animationFrame = requestAnimationFrame(animateScroll);
      }
    };

    this.animationFrame = requestAnimationFrame(animateScroll);
  }
}

if (!customElements.get('back-to-top-button')) {
  customElements.define('back-to-top-button', BackToTopButton);
}
})();
